import { useQuery, useMutation } from "@tanstack/react-query";
import { getProducts, renewSubscription } from "../../sevices/apiSubscription";

export function useProducts() {
  const {
    isLoading,
    data,
    error,
    isError,
  } = useQuery({
    queryKey: ["products"],
    queryFn: getProducts,
  });

  return { isLoading, error, data, isError };
}

export function useRenewSubscription() {
  return useMutation({
    mutationFn: renewSubscription,
  });
}

